import { Box, Spinner, Text } from '@chakra-ui/react'

interface NumberBoxProps {
  number: number
  text?: string
  isLoading?: boolean
}

export const NumberBox = ({ number, isLoading, text }: NumberBoxProps) => {
  return (
    <Box display='flex' alignItems='center' justifyContent='center' h='26px' w='auto' bg='gray.100' borderRadius='8px' pl={1.5} pr={1.5}>
      {isLoading ? (
        <Spinner size={'xs'} />
      ) : (
        <Text fontSize={12} fontWeight={500} color='#0D0D0DB3'>
          {number} {text}
        </Text>
      )}
    </Box>
  )
}
